/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCurrentLocation32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        d='M15.504 22.68l.496.187.497-.188a.752.752 0 01-.993 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M16.127 7.368a3.632 3.632 0 100 7.264 3.632 3.632 0 000-7.264zM13.994 11a2.132 2.132 0 114.265 0 2.132 2.132 0 01-4.265 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M15.504 22.68l.496.187.497-.188h.001l.005-.005.017-.015a20.67 20.67 0 00.292-.267 36.33 36.33 0 003.269-3.486c.893-1.095 1.802-2.359 2.49-3.671.683-1.304 1.179-2.712 1.179-4.08 0-4.503-3.464-7.905-7.75-7.905s-7.75 3.402-7.75 7.904c0 1.369.496 2.777 1.18 4.081.687 1.313 1.595 2.576 2.49 3.67a36.33 36.33 0 003.56 3.754l.017.015.005.004.002.002zM9.75 11.154C9.75 7.47 12.554 4.75 16 4.75s6.25 2.72 6.25 6.404c0 1.026-.379 2.184-1.008 3.385-.625 1.192-1.466 2.37-2.323 3.418A34.789 34.789 0 0116 21.097a34.789 34.789 0 01-2.92-3.14c-.855-1.049-1.697-2.226-2.322-3.418-.63-1.2-1.008-2.36-1.008-3.385z'
      />
      <path
        fill='currentColor'
        d='M5 18.25a.75.75 0 00-.75.75v9c0 .414.336.75.75.75h22a.75.75 0 00.75-.75v-9a.75.75 0 00-.75-.75h-4v1.5h3.25v7.5H5.75v-7.5H9v-1.5H5z'
      />
    </svg>
  );
}

export default SvgCurrentLocation32;
